import React from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { W } from "./wizardTokens";

function extOf(name) {
  const ext = (name.split(".").pop() || "").toUpperCase().slice(0, 4);
  return ext === "DOCX" ? "DOC" : ext === "PPTX" ? "PPT" : ext === "XLSX" ? "XLS" : ext;
}

export default function DocUploadStep({ queue }) {
  const allDone = queue.every((q) => q.status === "done" || q.status === "failed");
  const failures = queue.filter((q) => q.status === "failed").length;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      {allDone && (
        <Box sx={{ display: "grid", gridTemplateColumns: "32px minmax(0,1fr)", gap: "12px", alignItems: "center", p: "14px 16px", borderRadius: "10px", bgcolor: failures ? W.warnBg : W.successBg }}>
          <Box sx={{ width: 32, height: 32, borderRadius: "50%", bgcolor: failures ? W.warn : W.success, color: "#fff", display: "grid", placeItems: "center", fontWeight: 700 }}>{failures ? "!" : "✓"}</Box>
          <Typography sx={{ fontSize: "14px" }}>
            <b>{queue.length - failures} file{queue.length - failures === 1 ? "" : "s"} added to the Document Library.</b>
            {failures ? ` ${failures} failed.` : " Assign them to a course from the Documents tab."}
          </Typography>
        </Box>
      )}
      <Box sx={{ border: `1px solid ${W.line}`, borderRadius: "10px", overflow: "hidden" }}>
        {queue.map((q, i) => (
          <Box key={`${q.file.name}-${i}`} sx={{ display: "grid", gridTemplateColumns: "36px minmax(0,1fr) auto", gap: "12px", alignItems: "center", p: "10px 14px", borderTop: i ? `1px solid ${W.line}` : "none" }}>
            <Box sx={{ width: 36, height: 36, borderRadius: "8px", bgcolor: W.surface2, display: "grid", placeItems: "center", fontSize: "10px", fontWeight: 700, fontFamily: "var(--font-mono)" }}>{extOf(q.file.name)}</Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={{ fontSize: "14px", fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{q.file.name}</Typography>
              <Typography sx={{ fontSize: "12.5px", color: q.status === "failed" ? W.danger : W.ink3 }}>
                {q.status === "waiting" ? "Waiting" : q.status === "uploading" ? "Uploading…" : q.status === "failed" ? q.error || "Upload failed" : "Uploaded"}
              </Typography>
            </Box>
            {q.status === "uploading" ? <CircularProgress size={16} thickness={5} /> : q.status === "done" ? <Box sx={{ color: W.success, fontWeight: 700 }}>✓</Box> : q.status === "failed" ? <Box sx={{ color: W.danger, fontWeight: 700 }}>✕</Box> : null}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
